import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { TextM } from '../../../../infra/dls/components/typography';
import { t } from '../../../../infra/i18n';
import styles from './styles.module.scss';
export var ListingNavigation = function (_a) {
    var _b, _c;
    var activeView = _a.activeView, onViewChange = _a.onViewChange;
    return (_jsxs("div", { className: styles['listing-navigation-wrapper'], children: [_jsx(TextM, { className: classNames(styles['listing-navigation-item'], (_b = {},
                    _b[styles.active] = activeView === 'list',
                    _b)), color: activeView === 'list' ? 'brand' : 'tertiary', onClick: function () { return onViewChange('list'); }, children: t('engage:navigation.all_campaigns') }), _jsx(TextM, { className: classNames(styles['listing-navigation-item'], (_c = {},
                    _c[styles.active] = activeView === 'automated',
                    _c)), color: activeView === 'automated' ? 'brand' : 'tertiary', onClick: function () { return onViewChange('automated'); }, children: t('engage:navigation.automated') })] }));
};
